export const styles = {
  box: {
    width: '100%',
    my: 2,
  },
  counter: {
    fontSize: '0.8rem',
  },
  exportButton: {
    border: 'none',
    typography: 'subtitle3',
    color: '',
    gap: '7px',
  },
};
